export class TransportePessoasDTO {
  quantidadePessoas: number;
  limitacao: boolean;
  acamado: boolean;
  operado: boolean;
  outraLimitacao?: string;
  observacao?: string;
  constructor(
    quantidadePessoas: number,
    limitacao: boolean,
    acamado: boolean,
    operado: boolean,
    outraLimitacao?: string,
    observacao?: string,
  ) {
    this.acamado = acamado;
    this.limitacao = limitacao;
    this.observacao = observacao;
    this.operado = operado;
    this.outraLimitacao = outraLimitacao;
    this.quantidadePessoas = quantidadePessoas;
  }
}
